import { useOrchestratorApi } from '@/composables/orchestrator/useOrchestratorApi'
import useWebsocket from '../useWebsocket'
import { setLocaleHeader, useWorkflow } from '@/composables/workflow/useWorkflow'
import type { SessionContext, SessionStrategy } from '../../types'
import {
    awaitFirstView,
    advance,
    changeLanguage,
    currentTaskEvents,
    disposeSession,
    latestTaskEvent,
    resetRun,
    resolveLayout,
    watchWorkflowEnd,
} from './shared'

export const createTokenV3Strategy = (): SessionStrategy => {
    let connecting: Promise<void> | undefined

    const connect = (ctx: SessionContext) => {
        const { workflowId } = useWorkflow()

        return useWebsocket().initialize(ctx.token, `${workflowId.value}`, ctx.mode)
    }

    return {
        kind: 'token-v3',

        // the channel is opened here but deliberately not awaited, so remote options and custom
        // css keep downloading while the handshake runs
        preConnect: async (ctx: SessionContext) => {
            connecting = connect(ctx)
        },

        validateSession: async () => {},

        resolveWorkflow: async () => {},

        ensureConnected: async (ctx: SessionContext) => {
            await (connecting || connect(ctx))
        },

        start: async () => {
            const { workflowId, token } = useWorkflow()

            const response = await useOrchestratorApi().post(
                `/workflows/${workflowId.value}/run`,
                {
                    Authorization: `Bearer ${token.value}`,
                },
            )

            if (response.data?.locale) {
                setLocaleHeader(response.data.locale)
            }

            return response.data
        },

        awaitFirstView,
        advance,
        changeLanguage,
        resolveLayout,
        currentTaskEvents,
        latestTaskEvent,
        watchWorkflowEnd,

        resetRun: () => {
            connecting = undefined
            resetRun()
        },

        disposeSession: () => {
            connecting = undefined
            disposeSession()
        },
    }
}
